import { Review } from "@/types/reviewType";
import { atom } from "recoil";

export const reviewTagsState = atom<Array<string>>({
  default: [],
  key: "reviewTags",
});

export const reviewContentState = atom({
  default: "",
  key: "reviewContent",
});

export const reviewBadContentState = atom({
  default: "",
  key: "badreviewContent",
});

export const reviewStarsState = atom({
  default: 0,
  key: "reviewStars",
});

export const processTagsState = atom<number>({
  default: -1,
  key: "processTags",
});

export const sincerityTagsState = atom<number>({
  default: -1,
  key: "sincerityTags",
});

export const priceTagsState = atom<number>({
  default: -1,
  key: "priceTags",
});

export const additionalTagsState = atom<number>({
  default: -1,
  key: "additionalTags",
});

export const editingFuneralReviewState = atom<Review | undefined>({
  default: undefined,
  key: "editingFuneralDirectorReview",
});

export const orderByState = atom({
  key: "orderByState",
  default: "-created_at",
});
